import { sortChatsByFavorite } from './sortChatsByFavorite';

import type { Topic } from 'pages/ParentHelper/types';

export const sortChatsByDateAndFavorite = (chatA: Topic, chatB: Topic) => {
  if (chatA.isFavorite !== chatB.isFavorite) {
    return sortChatsByFavorite(chatA);
  }

  return (
    new Date(chatB.lastUpdatedDate).getTime() -
    new Date(chatA.lastUpdatedDate).getTime()
  );
};
